import script from "./WidgetHomeLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetHomeLogo.vue?vue&type=script&setup=true&lang=js"

import "./WidgetHomeLogo.vue?vue&type=style&index=0&id=6721626c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6721626c"]])

export default __exports__